//These are defined in a separate file because enums cannot be defined in .d.ts files

export enum PluginFields {
    order = "order",
    product = "product",
    user = "user",
    ship = "ship",
    call = "call",
    voyage = "voyage",
    contract = "contract",
    declaration = "declaration",
    agreementTypes = "agreementTypes",
    location = "location",
    cargoMonitor = "cargoMonitor",
    voyageMonitor = "voyageMonitor",
    callMonitor = "callMonitor",
    shipMonitor = "shipMonitor",
    locationMonitor = "locationMonitor",
    cargoExport = "cargoExport",
    cargoAction = "cargoAction",
    address = "address",
    dashboard = "dashboard",
    cargoEncryption = "cargoEncryption"
}

export enum StatusTypes {
    "NONE",
    "CARGO",
    "CALL",
    "VOYAGE",
    "ORDER",
    "CHARTER"
}

export enum Day {
	Monday = "monday",
	Tuesday = "tuesday",
	Wednesday = "wednesday",
	Thursday = "thursday",
	Friday = "friday",
	Saturday = "saturday",
	Sunday = "sunday"
}
